export default {
  ETH: {
    address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
    img: require('@/assets/images/coin/eth.png'),
    decimals: 18,
    name: 'Ether',
    symbol: 'ETH'
  },
  FX: {
    address: '0x8c15ef5b4b21951d50e53e4fbda8298ffad25057',
    img: require('@/assets/images/coin/fx.png'),
    decimals: 18,
    name: 'f(x) Coin',
    symbol: 'FX'
  },
  NPXS: {
    address: '0xa15c7ebe1f07caf6bff097d8a589fb8ac49ae5b3',
    img: require('@/assets/images/coin/npxs.png'),
    decimals: 18,
    name: 'Pundi X',
    symbol: 'NPXS'
  },
  // TODO 把xs改成pundix
  XS: {
    address: '0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38',
    img: require('@/assets/images/coin/npxs.png'),
    decimals: 18,
    name: 'PUNDIX',
    symbol: 'PUNDIX'
  }
}
